import React from 'react';
import PropTypes from 'prop-types';

import ProgressBar from "components/ProgressBar";
import PimStatusBadge from "components/PimStatusBadge";
import StyledCard from "components/card/StyledCard";

import DataLine from "./components/DataLine";

ProductInfos.propTypes = {
    picture: PropTypes.string,
    price: PropTypes.number,
    price30days: PropTypes.number,
    stock: PropTypes.number,
    status: PropTypes.number,
    completeness: PropTypes.number
};

function ProductInfos({
    picture = null,
    price = 0,
    price30days = 0,
    stock = 0,
    status = 0,
    completeness = 0
}) {
    return (
        <StyledCard style={{display: 'flex', flexDirection: 'column'}}>
            <div style={{
                maxHeight: '144px',
                paddingTop: '24px',
                paddingBottom: '24px',
                alignSelf: 'center'
            }}>
                <img
                    src={picture}
                    alt={'product picture'}
                    style={{
                        objectFit: 'contain',
                        height: '100%'
                    }}
                />
            </div>
            <div style={{display: 'flex', flexDirection: 'column', gap: '12px'}}>
                <DataLine label={'Prix'} value={(<b>{price}</b>)} />
                <DataLine label={'Prix bas 30j'} value={price30days} />
                <DataLine label={'Stock'} value={stock} />
                <DataLine label={'Statut'} value={<PimStatusBadge status={status} /> } />
                <DataLine label={'Complétude'} value={<ProgressBar percentage={completeness} />} />
            </div>
        </StyledCard>
    );
}

export default ProductInfos;
